import React, { useEffect, useState } from 'react';
import {
  Image, TouchableOpacity, View,
} from 'react-native';
import { CheckBox } from 'react-native-elements';
import { Colors } from 'react-native-paper';
import Icon from 'react-native-vector-icons/Ionicons';

import { coin } from '../../../assets/icons';
import logo_purple from '../../../assets/images/logo_purple.png';
import { appColors } from '../../../assets/styles/global';
import { AppHeader, VideoPlayer } from '../../../components/common';
import { AppText } from '../../../components/form';
import { handleWebBrowser, pixelDimensions } from '../../../config/utils';
import styles from './styles';

const onlineGymDetails = ({ navigation, route }) => {
  const [people, changePeople] = useState([]);
  const [checked, changeCheck] = useState(false);
  useEffect(() => {
    generatePeople();
  }, []);
  const { details } = route.params;

  const generatePeople = () => {
    const base = [];
    for (let i = 0; i < 20; i++) {
      base.push(i < details.actualParticipants ? '+' : '-');
    }
    changePeople(base);
  };
  const handleCheck = () => {
    navigation.navigate('Worker Online Gym Eval', { id_aula: details.id_aula, moedas: details.moedas });
    changeCheck(!checked);
  };
  return (
    <View style={styles.viewBase}>
      <AppHeader title="Detalhes da Aula" hasBack navigation={navigation} />
      <View style={styles.content}>
        <View style={[styles.viewListItem, { marginBottom: pixelDimensions(1) }]}>
          <View style={styles.viewListItemTop}>
            <View style={styles.viewFlexCenter}>
              <View style={styles.viewWhiteCircle}>
                <AppText style={[styles.textList, styles.textPurple]}>{1 + details.index}</AppText>
              </View>
              <AppText style={[styles.textList]}>{details.titulo}</AppText>
            </View>
            <View style={styles.viewFlexCenter}>
              <View style={styles.viewInterval}>
                <AppText style={[styles.textList]}>{`${details.horario_inicio} - ${details.horario_fim}`}</AppText>
              </View>
            </View>
          </View>
        </View>
        {details.cd_tipo === 'ONLINE' && (
          <>
            <View style={styles.viewFlexCenter}>
              {
            !!people.length && people.map((item, index) => (
              <Icon key={`icon-${index}`} name="person" style={[styles.iconPerson, item === '+' && styles.iconPersonFull]} />
            ))
          }
            </View>
            <AppText style={{ color: appColors.primary, textAlign: 'center' }}>

              O Profissional avisará
              quando a sala estiver com sua capacidade máxima.

            </AppText>
          </>
        )}
        <View style={styles.viewVideoContainer}>
          {
            details.cd_tipo === 'ONLINE'
            && (
            <TouchableOpacity style={styles.viewVideoFrame} onPress={() => handleWebBrowser(details.link_reuniao)}>
              <Icon name="play-circle" style={styles.iconPlay} />
              <Image source={logo_purple} style={styles.imageLogo} />
              <AppText size="bold" style={styles.textEnter}>Entrar na Aula</AppText>
            </TouchableOpacity>
            )
          }
          {
            details.cd_tipo === 'GRAVADA'
            && (
            <VideoPlayer url={details.video} />
            )
          }
          <View style={styles.viewRowBetween}>
            <View style={{ flexDirection: 'row' }}>
              <Image source={coin} style={styles.imageCoin} />
              <View style={styles.viewCoinContainer}>
                <AppText size="bold" style={styles.textVale}>{`Vale ${details.moedas}`}</AppText>
                <AppText style={styles.textCoin}>MOEDAS</AppText>
              </View>
            </View>
            <View>
              <CheckBox
                checked={checked}
                checkedColor={appColors.primary}
                onPress={handleCheck}
                containerStyle={{
                  backgroundColor: Colors.grey300, padding: 0, margin: 0, borderColor: 'transparent',
                }}
                title={<AppText style={{ fontSize: pixelDimensions(4) }}>Aula Concluída</AppText>}
              />
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default onlineGymDetails;
